import LocatorApi from '@/lib/LocatorApi';
export default async function homeRecyclingCentreLoader({ params, }) {
    const postcode = params.postcode;
    const locations = LocatorApi.getInstance().get(`locations/${postcode}?limit=120&radius=25`);
    return {
        locations: locations,
    };
}
